import { pick } from 'es-toolkit';
import { COUPON_PATH } from 'src/common/constants/paths';
import { COUPON_FLOW } from 'src/common/constants/subscription/flow';
import parseQuery from '../queryString/parse';

export default function getCouponRedirect(hasActiveSub, location) {
  const query = parseQuery(location?.search || '');
  const inCouponSubFlow = query[COUPON_FLOW];

  if (hasActiveSub && inCouponSubFlow) {
    return {
      pathname: COUPON_PATH,
      query: pick(query, ['source']),
    };
  }

  return undefined;
}
